 
export type CategoriaServicosCor =
  | 'azul'
  | 'vermelho'
  | 'roxo'
  | 'amarelo'
  | 'verde'
  | 'rosa'
  | 'laranja'
  /** O "Cinza Neutro" (#6B7280) do adm: só chega pela tradução do hex (`corDaCategoria`). */
  | 'cinza';

export type CategoriaServicosTipo = 'presencial' | 'digital' | 'cadastro';

export interface CategoriaServicosTipoOpcao {
  tipo: CategoriaServicosTipo;
  rotulo: string;
  rotuloFiltro: string;
  icone: string;
}

export const CATEGORIA_SERVICOS_TIPOS: readonly CategoriaServicosTipoOpcao[] = [
  { tipo: 'presencial', rotulo: 'Presencial', rotuloFiltro: 'Presenciais', icone: 'building-2' },
  { tipo: 'digital', rotulo: 'Digital', rotuloFiltro: 'Digitais', icone: 'monitor-play' },
  { tipo: 'cadastro', rotulo: 'Cadastro', rotuloFiltro: 'De cadastro', icone: 'id-card' },
];

export interface CategoriaServicosItem {
  id: string;
  titulo: string;
  descricao: string;
  cor: CategoriaServicosCor;
  tipos: readonly CategoriaServicosTipo[];
  icone: string;
  /**
   * O destino do card: caminho a partir da raiz, sem a barra inicial, podendo ter mais de
   * um segmento — `financas` (página de serviço) ou `servicos/saude` (categoria em "Todos
   * os Serviços"). O card o usa como URL em texto: no array de comandos do `routerLink`,
   * a barra do meio sairia codificada (`servicos%2Fsaude`).
   */
  rotaPagina: string;
}
 
export interface CategoriaServicosGrupo {
  id: string;
  titulo?: string;
  categorias: readonly CategoriaServicosItem[];
}
